<template>
  <v-container v-if="loading" fill-height :pa-0="$vuetify.breakpoint.smAndDown">
    <v-layout align-center justify-center>
      <v-flex xs12>
        <loading/>
      </v-flex>
    </v-layout>
  </v-container>
  <v-container fluid :pa-0="$vuetify.breakpoint.smAndDown" v-else>
    <v-card>
      <v-card-title>
        <document-toolbar
          :id="id"
          :name="name"
          :title="title"
          :created_on="document.created_on"
          :addItems="false"
          @openDocument="openDocument"
          @closeDocument="closeDocument"
        />
      </v-card-title>
      <v-card-text>
        <v-chip color="accent" dark class="elevation-0" selected>
          {{ document.tip_dostavki }}
        </v-chip>
        {{ document.address }}
      </v-card-text>
      <component
        :is="rashodnayaNakladnayaComponent"
        :summa="document.summa"
        :records="document.records"
      />
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" @click="excel" :icon="$vuetify.breakpoint.xsOnly">
          <v-icon v-if="$vuetify.breakpoint.xsOnly">
            mdi-file-excel
          </v-icon>
          <template v-else>
            Excel
          </template>
        </v-btn>
        <v-btn color="secondary" @click="closeDocument" :icon="$vuetify.breakpoint.xsOnly">
          <v-icon v-if="$vuetify.breakpoint.xsOnly">
            mdi-close
          </v-icon>
          <template v-else>
            Закрыть
          </template>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import documentTweaks from '../mixins/documentTweaks'
import rashodnayaNakladnayaTable from './RashodnayaNakladnayaTable'
import rashodnayaNakladnayaList from './RashodnayaNakladnayaList'

export default {
  name: 'rashodnaya-nakladnaya',
  mixins: [
    documentTweaks
  ],
  components: {
    rashodnayaNakladnayaTable,
    rashodnayaNakladnayaList
  },
  data () {
    return {
      name: 'rashodnayanakladnaya',
      title: 'Заказ',
      document: {
        address: '',
        tip_dostavki: ''
      }
    }
  },
  computed: {
    rashodnayaNakladnayaComponent () {
      return this.$vuetify.breakpoint.smAndDown ? 'rashodnaya-nakladnaya-list' : 'rashodnaya-nakladnaya-table'
    }
  }
}
</script>

<style>
</style>
